// extracted by mini-css-extract-plugin
var _1 = "SettingsFieldGroup-moduleSettingsFieldGroup__Fuoti";
var _2 = "SettingsFieldGroup-moduletitle__wHhsi";
export { _1 as "SettingsFieldGroup", _2 as "title" }
